const IS_DEV =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

export const IS_DEVELOPMENT = IS_DEV;
export const BASE_API_URL = "/";
